module.exports = __webpack_public_path__ + "static/media/lucelogo.aa15c420.png";